import $ from 'jquery'

const resizeTextarea = (id) => {
  let textarea = $('#'+id)[0]
  textarea.style.height = ""
  textarea.style.height = textarea.scrollHeight + 3 + "px"
}

export {resizeTextarea}
